import React from 'react';
import { useForm } from 'react-hook-form';

const MakeAdmin = () => {
    const { register, handleSubmit, reset } = useForm();
    const onSubmit = data => {
        fetch('https://infinite-river-22082.herokuapp.com/users/admin', {
            method: 'PUT',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(data => {
                if (data.modifiedCount > 0) {
                    alert('Admin Added!')
                    reset();
                }
            })
    };
    return (
        <div className='container'>
            <h2 className='title text-center'>Make An Admin</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <input className='mb-3 w-50' {...register("email")} />
                <br />
                <input style={{ fontFamily: 'Poppins', backgroundColor: 'black', color: 'white', border: 'none', borderRadius: '20px' }} className='w-25' type="submit" value='Make Admin' />
            </form>
        </div>
    );
};

export default MakeAdmin;